import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { AvailabilityFilter } from "./component";

import { IStoreState } from "../../../../reducers/types";
import {
  setAmenitiesFilter,
  setDiscountFilter,
  setFreeCancelFilter,
  setHotelNameFilter,
  setLoyaltyProgramsFilter,
  setMaxPriceFilter,
  setMealPlanFilter,
  setPackagesHotelsAvailabilitySortOption,
  setPolicyFilter,
  setStarRatingsFilter,
} from "../../actions/actions";
import {
  getAppliedHotelAvailabilityFilterCount,
  getHotelAvailabilityAmenitiesFilter,
  getHotelAvailabilityCurrency,
  getHotelAvailabilityFreeCancelFilter,
  getHotelAvailabilityHotelNameFilter,
  getHotelAvailabilityLoyaltyProgramsFilter,
  getHotelAvailabilityMaxPriceFilter,
  getHotelAvailabilityMinMaxPriceRange,
  getHotelAvailabilityPolicyFilter,
  getHotelAvailabilityStarRatingsFilter,
  getPackagesAvailabilityCallState,
  getPackagesAvailabilityLodgingsSortOption,
  hasChangedHotelAvailabilityAmenitiesFilter,
  hasChangedHotelAvailabilityPolicyFilter,
  hasChangedHotelAvailabilityLoyaltyFilter,
  hasChangedHotelAvailabilityStarRatingsFilter,
  getHotelAvailabilityMealPlanFilter,
  getHotelAvailabilityPackageDiscountFilter,
  getHotelNameFilterAutocompleteOptions,
  getHotelAvailabilityShowHotelIdFilter,
} from "../../reducer";
import { Dispatch } from "@reduxjs/toolkit";
import {
  AmenityEnum,
  AppliedHotelFilterProperties,
  HotelStarRatingEnum,
  MealPlanKindEnum,
} from "redmond";
import { PackagesHotelsAvailabilitySortOption } from "../../reducer/state";

const mapStateToProps = (state: IStoreState) => ({
  starRatings: getHotelAvailabilityStarRatingsFilter(state),
  hasChangedStarRatingsFilter:
    hasChangedHotelAvailabilityStarRatingsFilter(state),
  amenities: getHotelAvailabilityAmenitiesFilter(state),
  hasChangedAmenitiesFilter: hasChangedHotelAvailabilityAmenitiesFilter(state),
  currency: getHotelAvailabilityCurrency(state),
  maxPrice: getHotelAvailabilityMaxPriceFilter(state),
  minMaxPriceRange: getHotelAvailabilityMinMaxPriceRange(state),
  hasFreeCancelFilter: getHotelAvailabilityFreeCancelFilter(state),
  hotelName: getHotelAvailabilityHotelNameFilter(state),
  isInPolicy: getHotelAvailabilityPolicyFilter(state),
  hasChangedPolicyFilter: hasChangedHotelAvailabilityPolicyFilter(state),
  hasChangedLoyaltyFilter: hasChangedHotelAvailabilityLoyaltyFilter(state),
  loyaltyPrograms: getHotelAvailabilityLoyaltyProgramsFilter(state),
  appliedFilterCount: getAppliedHotelAvailabilityFilterCount(state),
  packagesAvailabilityCallState: getPackagesAvailabilityCallState(state),
  sortOption: getPackagesAvailabilityLodgingsSortOption(state),
  mealPlanTypes: getHotelAvailabilityMealPlanFilter(state),
  onlyDiscountedProperties: getHotelAvailabilityPackageDiscountFilter(state),
  hotelNameFilterAutocompleteOptions:
    getHotelNameFilterAutocompleteOptions(state),
  selectedHotelId: getHotelAvailabilityShowHotelIdFilter(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: { trackingLocation: AppliedHotelFilterProperties["location"] }
) => {
  return {
    setStarRatingsFilter: (starRatings: HotelStarRatingEnum[]) =>
      dispatch(setStarRatingsFilter(starRatings, ownProps.trackingLocation)),
    setAmenitiesFilter: (amenities: AmenityEnum[]) =>
      dispatch(setAmenitiesFilter(amenities, ownProps.trackingLocation)),
    setMaxPriceFilter: (maxPrice: number) =>
      dispatch(setMaxPriceFilter(maxPrice, ownProps.trackingLocation)),
    setFreeCancelFilter: (hasFreeCancel: boolean) =>
      dispatch(setFreeCancelFilter(hasFreeCancel, ownProps.trackingLocation)),
    setHotelNameFilter: (hotelName: string, hotelId?: string) =>
      dispatch(
        setHotelNameFilter(hotelName, hotelId, ownProps.trackingLocation)
      ),
    setPackagesHotelsAvailabilitySortOption: (
      sortOption: PackagesHotelsAvailabilitySortOption
    ) => dispatch(setPackagesHotelsAvailabilitySortOption(sortOption)),
    setPolicyFilter: (isInPolicy: boolean) =>
      dispatch(setPolicyFilter(isInPolicy)),
    setLoyaltyProgramsFilter: (loyaltyPrograms: string[]) =>
      dispatch(setLoyaltyProgramsFilter(loyaltyPrograms)),
    setMealPlanFilter: (mealPlanTypes: MealPlanKindEnum[]) =>
      dispatch(setMealPlanFilter(mealPlanTypes, ownProps.trackingLocation)),
    setDiscountFilter: (onlyDiscountedProperties: boolean) =>
      dispatch(
        setDiscountFilter(onlyDiscountedProperties, ownProps.trackingLocation)
      ),
  };
};
const connector = connect(mapStateToProps, mapDispatchToProps);

export type AvailabilityFilterConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedAvailabilityFilter = withRouter(
  connector(AvailabilityFilter)
);
